import type { ReactNode } from 'react';

export const symbol_shopping_cart_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M640-452h-35l-59-60h85l126-228H316l-60-60h529q26 0 38 21.5t-2 46.5L680-476q-6 11-15 17.5t-25 6.5ZM287-81q-30 0-51-21t-21-51q0-30 21-51t51-21q30 0 51 21t21 51q0 30-21 51t-51 21Zm543 25L595-289H277q-38 0-56-27.5t1-59.5l70-117-86-187L67-819q-9-9-8.5-21t9.5-21q9-9 21.5-9t21.5 9L873-99q9 9 8.5 21.5T872-56q-9 9-21 9t-21-9ZM535-349 434-453h-95l-63 104h259Zm96-163h-85 85Zm6.5 410Q616-123 616-153t21.5-51q21.5-21 50.5-21t50.5 21q21.5 21 21.5 51t-21.5 51Q717-81 688-81t-50.5-21Z"
		/>
	</svg>
);
